module.exports = __webpack_public_path__ + "static/img/ZM@3x.779311cc.jpg";